<template>
  <div class="container-fluid">

    <!-- ===== Bottom Navigation ===== -->
    <nav class="mobile-bottom-nav" v-if="isInvoiceOnly">
      <div class="mobile-bottom-nav__item mobile-bottom-nav__item--active">
        <a href="/app/invoices" class="mobile-bottom-nav__item-content">
          <i class="fas fa-home fa-2x"></i> Home
        </a>
      </div>

      <div class="mobile-bottom-nav__item">
        <a href="/sales" class="mobile-bottom-nav__item-content">
          <i class="fas fa-clipboard-list fa-2x"></i> Sales
        </a>
      </div>

      <div class="mobile-bottom-nav__item">
        <a href="/customers" class="mobile-bottom-nav__item-content">
          <i class="fas fa-user-friends fa-2x"></i> Customers
        </a>
      </div>

      <div class="mobile-bottom-nav__item">
        <a href="/expenses" class="mobile-bottom-nav__item-content">
          <i class="fas fa-clipboard-list fa-2x"></i> Expenses
        </a>
      </div>

      <div class="mobile-bottom-nav__item">
        <a @click.prevent="toggleSidebar('sidemenu')" class="mobile-bottom-nav__item-content">
          <i class="fas fa-ellipsis-v fa-2x"></i> More
        </a>
      </div>
    </nav>
    <nav class="mobile-bottom-nav" v-else-if="isGymOnly">
      <div class="mobile-bottom-nav__item mobile-bottom-nav__item--active">
        <a href="/subscriptions" class="mobile-bottom-nav__item-content">
          <i class="fas fa-users fa-2x"></i> Members
        </a>
      </div>

      <div class="mobile-bottom-nav__item" v-if="isAdmin || hasPermission('subscriptions.checkin')">
        <a href="/subscription-checkin" class="mobile-bottom-nav__item-content">
          <i class="fas fa-door-open fa-2x"></i> Front desk
        </a>
      </div>
      <div class="mobile-bottom-nav__item" v-else>
        <a href="/customers" class="mobile-bottom-nav__item-content">
          <i class="fas fa-user-friends fa-2x"></i> Customers
        </a>
      </div>

      <div class="mobile-bottom-nav__item">
        <a href="/subscription-packages" class="mobile-bottom-nav__item-content">
          <i class="fas fa-tags fa-2x"></i> Packages
        </a>
      </div>

      <div class="mobile-bottom-nav__item">
        <a href="/expenses" class="mobile-bottom-nav__item-content">
          <i class="fas fa-clipboard-list fa-2x"></i> Expenses
        </a>
      </div>

      <div class="mobile-bottom-nav__item">
        <a @click.prevent="toggleSidebar('sidemenu')" class="mobile-bottom-nav__item-content">
          <i class="fas fa-ellipsis-v fa-2x"></i> More
        </a>
      </div>
    </nav>
    <nav class="mobile-bottom-nav" v-else-if="isHotelOnly">
      <div class="mobile-bottom-nav__item mobile-bottom-nav__item--active">
        <a href="/reservations-today" class="mobile-bottom-nav__item-content">
          <i class="fas fa-concierge-bell fa-2x"></i> Today
        </a>
      </div>

      <div class="mobile-bottom-nav__item">
        <a href="/make-reservations" class="mobile-bottom-nav__item-content">
          <i class="fas fa-bed fa-2x"></i> Rooms
        </a>
      </div>

      <div class="mobile-bottom-nav__item">
        <a href="/reservations" class="mobile-bottom-nav__item-content">
          <i class="fas fa-calendar-check fa-2x"></i> Bookings
        </a>
      </div>

      <div class="mobile-bottom-nav__item">
        <a href="/expenses" class="mobile-bottom-nav__item-content">
          <i class="fas fa-clipboard-list fa-2x"></i> Expenses
        </a>
      </div>

      <div class="mobile-bottom-nav__item">
        <a @click.prevent="toggleSidebar('sidemenu')" class="mobile-bottom-nav__item-content">
          <i class="fas fa-ellipsis-v fa-2x"></i> More
        </a>
      </div>
    </nav>
    <nav class="mobile-bottom-nav" v-else>
      <div class="mobile-bottom-nav__item mobile-bottom-nav__item--active">
        <a :href="userDetails.default_route || '/app'" class="mobile-bottom-nav__item-content">
          <i class="fas fa-home fa-2x"></i> Home
        </a>
      </div>

      <div class="mobile-bottom-nav__item">
        <a href="/orders" class="mobile-bottom-nav__item-content">
          <i class="fas fa-clipboard-list fa-2x"></i> Orders
        </a>
      </div>

      <div class="mobile-bottom-nav__item">
        <a href="/inventory" class="mobile-bottom-nav__item-content">
          <i class="fas fa-box fa-2x"></i> Inventory
        </a>
      </div>

      <div class="mobile-bottom-nav__item">
        <a href="/expenses" class="mobile-bottom-nav__item-content">
          <i class="fas fa-clipboard-list fa-2x"></i> Expenses
        </a>
      </div>

      <div class="mobile-bottom-nav__item">
        <a @click.prevent="toggleSidebar('sidemenu')" class="mobile-bottom-nav__item-content">
          <i class="fas fa-ellipsis-v fa-2x"></i> More
        </a>
      </div>
    </nav>

    <!-- ===== Crucial Notification Overlay ===== -->
    <transition name="crucial-slide">
      <div v-if="crucialNotification" class="crucial-notif-bar" role="alert">
        <div class="crucial-notif-inner">
          <span class="crucial-notif-icon">
            <i class="bi bi-megaphone-fill"></i>
          </span>
          <div class="crucial-notif-content">
            <strong>{{ crucialNotification.data && crucialNotification.data.title }}</strong>
            <span class="crucial-notif-body">{{ crucialNotification.data && crucialNotification.data.body }}</span>
          </div>
          <div class="crucial-notif-actions">
            <a
              v-if="crucialNotification.data && crucialNotification.data.url"
              :href="crucialNotification.data.url"
              class="btn btn-sm btn-primary"
              @click="dismissCrucial"
            >
              {{ (crucialNotification.data && crucialNotification.data.action) || 'View' }}
            </a>
            <button type="button" @click="dismissCrucial" class="crucial-close" aria-label="Dismiss" title="Dismiss">
              <i class="bi bi-x-lg"></i>
            </button>
          </div>
        </div>
      </div>
    </transition>

    <!-- ===== Notifications Sidebar ===== -->
    <b-sidebar v-model="isNotificationActive" right shadow width="85%" class="bg-light">
      <div class="px-3 py-2">

        <!-- Header -->
        <div class="d-flex justify-content-between align-items-center mb-2">
          <h5 class="mb-0 font-weight-bold">Notifications</h5>
          <a v-if="unreadCount" @click="readAll" class="text-primary" style="cursor:pointer;font-size:.82rem;">
            Mark all as read
          </a>
        </div>
        <hr class="mt-1 mb-2" />

        <!-- Unread -->
        <div v-if="notifications.unread && notifications.unread.length">
          <p class="text-muted mb-1" style="font-size:.72rem;text-transform:uppercase;font-weight:700;letter-spacing:.06em;">New</p>
          <div
            v-for="notification in notifications.unread"
            :key="notification.id"
            class="notif-item notif-item--unread mb-1"
          >
            <div
              class="notif-item-header"
              v-b-toggle="'notif-' + notification.id"
              @click="readNotification(notification.id)"
            >
              <span class="notif-dot"></span>
              <span class="notif-title">{{ notifTitle(notification) }}</span>
              <small class="notif-time text-muted ml-auto">{{ notifTime(notification) }}</small>
              <i class="bi bi-chevron-down notif-chevron ml-1"></i>
            </div>
            <b-collapse :id="'notif-' + notification.id">
              <div class="notif-body">
                <p class="mb-2 text-muted" style="font-size:.85rem;">
                  {{ (notification.data && notification.data.body) || 'No details available.' }}
                </p>
                <a
                  v-if="notification.data && notification.data.url"
                  :href="notification.data.url"
                  class="btn btn-sm btn-primary"
                >
                  {{ (notification.data && notification.data.action) || 'View' }}
                </a>
              </div>
            </b-collapse>
          </div>
        </div>

        <!-- Read (recent) -->
        <div v-if="recentRead.length" class="mt-3">
          <p class="text-muted mb-1" style="font-size:.72rem;text-transform:uppercase;font-weight:700;letter-spacing:.06em;">Recent</p>
          <div
            v-for="notification in recentRead"
            :key="notification.id"
            class="notif-item notif-item--read mb-1"
          >
            <div
              class="notif-item-header"
              v-b-toggle="'notif-read-' + notification.id"
            >
              <span class="notif-dot notif-dot--read"></span>
              <span class="notif-title text-muted">{{ notifTitle(notification) }}</span>
              <small class="notif-time text-muted ml-auto">{{ notifTime(notification) }}</small>
              <i class="bi bi-chevron-down notif-chevron ml-1"></i>
            </div>
            <b-collapse :id="'notif-read-' + notification.id">
              <div class="notif-body">
                <p class="mb-2 text-muted" style="font-size:.85rem;">
                  {{ (notification.data && notification.data.body) || 'No details available.' }}
                </p>
                <a
                  v-if="notification.data && notification.data.url"
                  :href="notification.data.url"
                  class="btn btn-sm btn-outline-secondary"
                >
                  {{ (notification.data && notification.data.action) || 'View' }}
                </a>
              </div>
            </b-collapse>
          </div>
        </div>

        <p v-if="!notifications.unread.length && !recentRead.length" class="text-muted text-center py-4">
          <i class="bi bi-bell-slash d-block mb-2" style="font-size:1.5rem;"></i>
          No notifications yet
        </p>

      </div>
    </b-sidebar>

    <!-- ===== Side Menu ===== -->
    <b-sidebar v-model="isMenuActive" right shadow class="bg-light">
      <div class="px-3 py-2">

        <!-- Company Header -->
        <div class="mb-1">
          <div v-if="isAdmin || hasPermission('can switch branches')">
            <div v-if="companyBranches.length > 1" class="dropdown">
              <h5 class="dropdown-toggle" data-toggle="dropdown">
                <i class="bi bi-buildings"></i>
                <span class="d-inline-block text-truncate" style="max-width:220px">
                  {{ companyDetails && companyDetails.name }}
                </span>
              </h5>
              <div class="dropdown-menu">
                <a
                  v-for="branch in companyBranches"
                  :key="branch.company && branch.company.id"
                  class="dropdown-item"
                  @click.prevent="switchCompanyBranch(branch.company && branch.company.id)"
                >
                  {{ branch.company && branch.company.name }}
                </a>
              </div>
            </div>
            <div v-else>
              <h5 class="text-truncate">
                <i class="bi bi-buildings"></i>
                {{ (companyDetails && companyDetails.name) || 'Company' }}
              </h5>
            </div>
          </div>
          <div v-else>
            <h5 class="text-truncate">
              <i class="bi bi-buildings"></i>
              {{ (companyDetails && companyDetails.name) || 'Company' }}
            </h5>
          </div>

          <a href="/billing-and-plans" class="d-block text-muted mt-1">
            <small>Billing & Plans</small>
          </a>

          <a
            v-if="unreadCount"
            @click.prevent="toggleSidebar('notif')"
            class="notification"
          >
            <i class="bi bi-bell"></i>
            <span class="badge">{{ unreadCount }}</span>
          </a>
        </div>

        <!-- Setup progress widget (persistent, non-dismissible) -->
        <div
          v-if="setupPercentage < 100 && setupMilestonesLoaded"
          class="setup-progress-widget"
          @click="openSetupCenter"
        >
          <div class="setup-progress-header">
            <span class="setup-progress-label">
              <i class="bi bi-rocket-takeoff mr-1"></i> Business Setup
            </span>
            <span class="setup-progress-pct" :style="{ color: setupColor }">{{ setupPercentage }}%</span>
          </div>
          <div class="setup-progress-bar-track">
            <div
              class="setup-progress-bar-fill"
              :style="{ width: setupPercentage + '%', background: setupColor }"
            ></div>
          </div>
          <p class="setup-progress-sub">{{ setupCompleted }} of {{ setupTotal }} milestones complete</p>
        </div>

        <ul class="sidemenu-list">
          <li v-if="isAdmin || hasPermission('view-analytics')">
            <a class="text-dark" :href="analyticsUrl"><i class="bi bi-speedometer"></i> Dashboard</a>
          </li>
        </ul>

        <hr class="m-0" />

        <!-- ===== SALES & OPERATIONS ===== -->
        <ul class="sidemenu-list">
          <li class="menu-section collapsible" @click="toggleSection('sales')">
            <span><i class="bi bi-cash"></i> &nbsp;Sales</span>
            <i class="bi" :class="collapsed.sales ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
          </li>
          <b-collapse :visible="collapsed.sales">
            <li v-if="!isInvoiceOnly && !isNoPos && userDetails.default_route !== '/makesale'">
              <a href="/makesale"><i class="bi bi-calculator"></i> Make a Sale</a>
            </li>
            <li v-if="!isInvoiceOnly && !isNoPos">
              <a href="/orders"><i class="bi bi-clipboard"></i> Orders</a>
            </li>
            <li v-if="!isInvoiceOnly && companySettings && companySettings.enable_opening_cash">
              <a href="/shift-cash-closings"><i class="bi bi-cash"></i> Cash Session</a>
            </li>
            <li v-if="!isInvoiceOnly && companySettings && companySettings.enable_shifts && companySettings.enable_shift_cash_closing">
              <a href="#" @click.prevent="closeShift" class="text-dark">
                <i class="bi bi-door-closed"></i> Close Shift Cash
              </a>
            </li>
            <li v-if="!isInvoiceOnly && !isNoPos && userDetails.company && userDetails.company.companysettings && userDetails.company.companysettings.has_kds">
              <a href="/kds"><i class="bi bi-fork-knife"></i> Kitchen (KDS)</a>
            </li>
            <li v-if="!isInvoiceOnly && userDetails.company && userDetails.company.companysettings && userDetails.company.companysettings.has_reservations">
              <a href="/reservations"><i class="bi bi-building-check"></i> Reservations</a>
            </li>
            <li v-if="!isInvoiceOnly && companySettings && companySettings.has_reservations">
              <a href="/reservations-today"><i class="bi bi-door-open"></i> Today (front desk)</a>
            </li>
            <li v-if="!isInvoiceOnly && companySettings && companySettings.has_reservations">
              <a href="/night-audit"><i class="bi bi-moon-stars"></i> Night audit</a>
            </li>
            <li v-if="!isInvoiceOnly && companySettings && companySettings.has_reservations && isAdmin">
              <a href="/reservation-dashboard"><i class="bi bi-bar-chart"></i> Reservation report</a>
            </li>
            <li v-if="companySettings && companySettings.has_projects">
              <a href="/projects"><i class="bi bi-kanban"></i> Projects</a>
            </li>
            <li v-if="!isInvoiceOnly && userDetails.company && userDetails.company.companysettings && (userDetails.company.companysettings.has_subscriptions || userDetails.company.companysettings.has_reservations)">
              <a href="/subscriptions"><i class="bi bi-arrow-counterclockwise"></i> Subscription</a>
            </li>
            <li v-if="!isInvoiceOnly && companySettings && companySettings.has_subscriptions && (isAdmin || hasPermission('subscriptions.checkin'))">
              <a href="/subscription-checkin"><i class="bi bi-door-open"></i> Front desk</a>
            </li>
            <li v-if="userDetails.company && userDetails.company.companysettings && userDetails.company.companysettings.has_invoices">
              <a href="/invoices"><i class="bi bi-receipt"></i> Invoices</a>
            </li>
            <li v-if="userDetails.company && userDetails.company.companysettings && userDetails.company.companysettings.has_invoices">
              <a href="/quotes"><i class="bi bi-file-earmark-text"></i> Estimates</a>
            </li>
            <li v-if="userDetails.company && userDetails.company.companysettings && userDetails.company.companysettings.has_invoices">
              <a href="/deliveries"><i class="bi bi-truck"></i> Deliveries</a>
            </li>
          </b-collapse>
        </ul>

        <hr />

        <!-- ===== INVENTORY & CUSTOMERS ===== -->
        <ul class="sidemenu-list" v-if="!isInvoiceOnly && !isGymOnly">
          <li class="menu-section collapsible" @click="toggleSection('inventory')">
            <span><i class="bi bi-tag"></i> &nbsp;Inventory</span>
            <i class="bi" :class="collapsed.inventory ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
          </li>
          <b-collapse :visible="collapsed.inventory">
            <li><a href="/inventory"><i class="bi bi-box"></i> Inventory</a></li>
            <template v-if="!isHotelOnly">
              <li><a href="/inventory-intelligence"><i class="bi bi-graph-up-arrow"></i> Intelligence</a></li>
              <li><a href="/wastes"><i class="bi bi-trash"></i> Wastes</a></li>
              <li><a href="/suppliers"><i class="bi bi-truck"></i> Suppliers</a></li>
            </template>
            <li v-if="companySettings && companySettings.has_manufacturing && hasPermission('view-manufacturing')">
              <a href="/manufacturing"><i class="bi bi-gear-wide-connected"></i> Manufacturing</a>
            </li>
          </b-collapse>
        </ul>

        <hr v-if="!isInvoiceOnly && !isGymOnly" />

        <ul class="sidemenu-list">
          <li class="menu-section collapsible" @click="toggleSection('customers')">
            <span><i class="bi bi-person-bounding-box"></i> &nbsp;Customers</span>
            <i class="bi" :class="collapsed.customers ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
          </li>
          <b-collapse :visible="collapsed.customers">
            <li><a href="/customers"><i class="bi bi-people"></i> Customers</a></li>
            <li><a href="/bnpl"><i class="bi bi-wallet2"></i> BNPL / Debtors</a></li>
          </b-collapse>
        </ul>

        <hr />

        <!-- ===== FINANCE & ADMIN ===== -->
        <ul class="sidemenu-list" v-if="!isInvoiceOnly">
          <li class="menu-section collapsible" @click="toggleSection('management')">
            <span><i class="bi bi-people"></i> &nbsp;Staff</span>
            <i class="bi" :class="collapsed.management ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
          </li>
          <b-collapse :visible="collapsed.management">
            <li v-if="isAdmin || hasPermission('can manage users') || hasPermission('manage-employees') || hasPermission('view-employees') || hasPermission('manage-roles-permissions')">
              <a href="/employees"><i class="bi bi-person-lines-fill"></i> Employees</a>
            </li>
            <li v-if="isAdmin">
              <a href="/payroll"><i class="bi bi-cash-stack"></i> Payroll</a>
            </li>
            <li v-if="isAdmin || hasPermission('can manage users') || hasPermission('manage-employees')">
              <a href="/attendance"><i class="bi bi-clock"></i> Attendance</a>
            </li>
          </b-collapse>
        </ul>

        <hr v-if="!isInvoiceOnly" />

        <!-- ===== REPORTS ===== -->
        <ul class="sidemenu-list">
          <li class="menu-section collapsible" @click="toggleSection('reports')">
            <span><i class="bi bi-bar-chart"></i> &nbsp;Reports</span>
            <i class="bi" :class="collapsed.reports ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
          </li>
          <b-collapse :visible="collapsed.reports">
            <li v-if="(isAdmin || hasPermission('view-analytics')) && !isInvoiceOnly && !isNoPos">
              <a :href="analyticsUrl"><i class="bi bi-graph-up"></i> Sales Reports</a>
            </li>
            <li v-if="isAdmin || hasPermission('view-financial-reports') || hasPermission('view-profit-loss') || hasPermission('export-financial-data')">
              <a href="/reports"><i class="bi bi-clipboard-data"></i> Financial Reports</a>
            </li>
            <li v-if="isAdmin && userDetails.company && userDetails.company.companysettings && userDetails.company.companysettings.has_invoices">
              <a href="/chart-of-accounts"><i class="bi bi-diagram-3"></i> Chart of Accounts</a>
            </li>
            <li v-if="isAdmin && userDetails.company && userDetails.company.companysettings && userDetails.company.companysettings.has_invoices">
              <a href="/banking"><i class="bi bi-bank"></i> Banking</a>
            </li>
              <li>
              <a href="/payment-transactions/sms-sync">
                <i class="bi bi-arrow-repeat"></i> Payment Transactions
              </a>
            </li>
            <li v-if="isAdmin && userDetails.company && userDetails.company.companysettings && userDetails.company.companysettings.has_invoices">
              <a href="/payment-transactions/ledger"><i class="bi bi-arrow-left-right"></i> Transactions</a>
            </li>
            <li v-if="!isInvoiceOnly && isAdmin && companySettings && companySettings.enable_shifts && companySettings.enable_shift_cash_closing">
              <a href="/shift-cash-closings">
                <i class="bi bi-cash-coin"></i> Shift Cash Closings
              </a>
            </li>

            <li v-if="isAdmin">
              <a href="#">
                <i class="bi bi-journal-text"></i> Activity Log
              </a>
            </li>
          </b-collapse>
        </ul>

        <hr />

        <!-- ===== ACCOUNT ===== -->
        <ul class="sidemenu-list">
          <li class="menu-section collapsible" @click="toggleSection('account')">
            <span><i class="bi bi-gear"></i> &nbsp;Account & Settings</span>
            <i class="bi" :class="collapsed.account ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
          </li>
          <b-collapse :visible="collapsed.account">
            <li v-if="isAdmin || hasPermission('can change settings') || hasPermission('change-general-settings') || hasPermission('change-inventory-settings')">
              <a href="/settings/general"><i class="bi bi-gear"></i> Settings</a>
            </li>
            <li v-if="dukakitPaymentsEnabled">
              <a href="/send-receive-money"><i class="bi bi-arrow-left-right"></i> Send &amp; Receive Money</a>
            </li>
            <li>
              <a href="/profile"><i class="bi bi-person-circle"></i> Profile</a>
            </li>
            <li>
              <a
                v-if="userDetails.affiliate"
                href="/affiliates"
              >
                <i class="bi bi-cash-coin"></i> Referrals
              </a>
              <a
                v-else
                href="#"
                @click.prevent="addMeToAffiliate"
              >
                <i class="bi bi-gift"></i> Refer & Earn
              </a>
            </li>
            <li>
              <a
                class="text-primary"
                target="_blank"
                href="https://wa.me/254755133133"
              >
                <i class="bi bi-whatsapp"></i> Support
              </a>
            </li>
          </b-collapse>
        </ul>
          <hr v-if="isAdmin" />
         <ul class="sidemenu-list" v-if="isAdmin">
          <li class="menu-section collapsible" @click="toggleSection('intelligence')">
            <span><i class="bi bi-cpu"></i> &nbsp;Intelligence & AI</span>
            <i class="bi" :class="collapsed.intelligence ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
          </li>
          <b-collapse :visible="collapsed.intelligence">
            <li><a href="/smart-tips"><i class="bi bi-lightbulb"></i> Smart Tips</a></li>
            <li v-if="companySettings && companySettings.sharagpt_enabled"><a href="/sharagpt"><i class="bi bi-chat-dots"></i> SharaGPT</a></li>
          </b-collapse>

        </ul>


        <!-- Super Admin -->
        <hr />
        <ul class="sidemenu-list" v-if="userDetails.isDukakit === 1 && isAdmin">
          <li class="menu-section collapsible" @click="toggleSection('admin')">
            <span><i class="bi bi-app"></i> &nbsp;DKT Internal</span>
            <i class="bi" :class="collapsed.admin ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
          </li>
          <b-collapse :visible="collapsed.admin">
            <li>
              <a href="/s-dashboard"><i class="bi bi-shield-lock"></i> Super Dashboard</a>
            </li>
          </b-collapse>
          <hr />
        </ul>




        <ul class="sidemenu-list">
          <li>
            <a class="text-dark" href="/logout" @click.prevent="logout">
              <i class="bi bi-box-arrow-right"></i> Sign Out
            </a>
          </li>
        </ul>

      </div>
    </b-sidebar>

    <!-- Role Error Modal -->
    <b-modal ref="roleNotSetModal" hide-footer hide-header>
      <div class="text-center py-5">
        <h3 class="text-danger">Role error!</h3>
        <p>No role has been set for this account.</p>
        <p>Please contact your admin.</p>
      </div>
    </b-modal>

  </div>
</template>


<script>
import { BSidebar, BButton } from 'bootstrap-vue'
import { mapGetters } from 'vuex'
import identityCache from '../../services/identityCache'
import branchSwitch from '../../services/branchSwitch'

export default {
  name: 'BottomMenu',

  components: {
    BSidebar,
    BButton,
  },

  data() {
    return {
      preferredDashboard: localStorage.getItem('preferred_dashboard') || 'classic',
      companyBranches: [],
      companyDetails: {},
      notifications: {
        all: [],
        unread: [],
      },
      isNotificationActive: false,
      isMenuActive: false,
      collapsed: {
        sales: false,
        reports: false,
        inventory: false,
        customers: false,
        management: false,
        account: false,
        admin: false,
        intelligence: false,
      },
      // Setup progress
      setupPercentage: 0,
      setupCompleted: 0,
      setupTotal: 11,
      setupMilestonesLoaded: false,
      // Crucial notification
      crucialNotification: null,
      notifPoller: null,
      seenCrucialIds: new Set(JSON.parse(localStorage.getItem('seenCrucialNotifIds') || '[]')),
      dukakitPaymentsEnabled: false,
    }
  },

  computed: {
    ...mapGetters(['userDetails']),

    analyticsUrl() {
      if (this.userDetails?.company?.beta_dashboard_only) return '/analytics/beta';
      return this.preferredDashboard === 'beta' ? '/analytics/beta' : '/analytics/sales';
    },

    csrf() {
      const token = document.querySelector('meta[name="csrf-token"]')
      return token ? token.getAttribute('content') : ''
    },

    roles() {
      return this.userDetails && this.userDetails.roles || []
    },

    permissions() {
      return this.userDetails && this.userDetails.permissions || []
    },

    // Owner has full access on the server too (Gate::before), so it gets the full menu.
    isAdmin() {
      return this.roles.some(r => r.name === 'Admin' || r.name === 'owner')
    },

    companySettings() {
      return this.userDetails?.company?.companysettings || null
    },

    isInvoiceOnly() {
      return this.companySettings?.primary_use_case === 'invoices_quotes'
    },

    // Gym / membership business: no POS — Members, Front desk and Packages
    // replace Orders/Inventory. Inventory data stays (packages link to products).
    isGymOnly() {
      return this.companySettings?.primary_use_case === 'subscriptions' && !!this.companySettings?.has_subscriptions
    },

    // Hotel / BnB: Today, Rooms and Bookings replace Orders/POS. Inventory
    // stays (rooms are reservable products).
    isHotelOnly() {
      return this.companySettings?.primary_use_case === 'reservations' && !!this.companySettings?.has_reservations
    },

    // Neither runs a till: hide Make a Sale, Orders, KDS, Sales reports.
    isNoPos() {
      return this.isGymOnly || this.isHotelOnly
    },

    unreadCount() {
      return this.notifications.unread.length
    },

    recentRead() {
      const unreadIds = new Set((this.notifications.unread || []).map(n => n.id))
      return (this.notifications.all || [])
        .filter(n => n.read_at && !unreadIds.has(n.id))
        .slice(0, 10)
    },

    setupColor() {
      if (this.setupPercentage >= 90) return '#28a745';
      if (this.setupPercentage >= 60) return '#fd7e14';
      return '#dc3545';
    },
  },

  mounted() {
    this.getUserCompanyDetails()
    this.getNotifications()
    this.loadSetupProgress()
    this.loadDukakitPaymentsStatus()
    // Poll for new notifications every 60 seconds
    this.notifPoller = setInterval(this.getNotifications, 60000)
    document.addEventListener('keydown', this.onCrucialKeydown)
  },

  beforeDestroy() {
    clearInterval(this.notifPoller)
    document.removeEventListener('keydown', this.onCrucialKeydown)
  },

  methods: {
    toggleSection(section) {
      Object.keys(this.collapsed).forEach(key => {
        this.collapsed[key] = key === section ? !this.collapsed[key] : false
      })
    },

    async logout() {
      // Clear identity-scoped caches (IndexedDB) BEFORE localStorage.clear(),
      // so no product/customer data from this session can survive for
      // whoever logs in next on this device.
      await identityCache.clearAll()
      this.$store.commit('resetStore')
      this.$store.commit('removeUserDetails')
      localStorage.clear()
      axios.post('/logout', { _token: this.csrf })
        .then(() => {
          window.location.href = '/login'
        })
        .catch(err => {
          console.error('Logout failed', err)
        })
    },

    hasPermission(name) {
      return this.permissions.some(p => p.name === name)
    },

    toggleSidebar(type) {
      if (type === 'notif') {
        this.isNotificationActive = !this.isNotificationActive
        this.isMenuActive = false
      } else {
        this.isMenuActive = !this.isMenuActive
        this.isNotificationActive = false
      }
    },

    // PERF: TTL-cached, mirrors the loadSetupProgress pattern below, to avoid
    // re-fetching on every page navigation (this component remounts on every
    // full page load since the app is a multi-page app, not an SPA).
    async getUserCompanyDetails() {
      const CACHE_KEY = 'apc_user_details_v1';
      const CACHE_TTL = 5 * 60 * 1000;
      try {
        const cached = JSON.parse(localStorage.getItem(CACHE_KEY) || 'null');
        if (cached && Date.now() - cached.ts < CACHE_TTL) {
          this.$store.commit('addUserDetails', cached.data)
          this.companyDetails = cached.data.company || {}
          this.companyBranches = cached.data.companybranches || []
          if (!cached.data.roles || cached.data.roles.length === 0) {
            this.$refs.roleNotSetModal.show()
          }
          return
        }
      } catch (_) {}

      try {
        const { data } = await axios.get('/api/user')

        this.$store.commit('addUserDetails', data)

        this.companyDetails = data.company || {}
        this.companyBranches = data.companybranches || []

        if (!data.roles || data.roles.length === 0) {
          this.$refs.roleNotSetModal.show()
        }

        try {
          localStorage.setItem(CACHE_KEY, JSON.stringify({ ts: Date.now(), data }))
        } catch (_) {}
      } catch (e) {
        console.error(e)
      }
    },

    async getNotifications() {
      try {
        const { data } = await axios.get('/api/notifications', { _silent: true })
        this.notifications.all = data.all || []
        this.notifications.unread = data.unread || []

        // Check for new crucial notifications
        const crucial = this.notifications.unread.find(
          n => n.data && n.data.priority === 'crucial'
        )
        if (crucial && !this.seenCrucialIds.has(crucial.id)) {
          this.seenCrucialIds.add(crucial.id)
          this.persistSeenCrucialIds()
          this.crucialNotification = crucial
          this.playNotificationSound()
        }
      } catch (e) {
        console.error(e)
      }
    },

    // Crucial banners are dismissed client-side even when the mark-as-read
    // request fails, so "seen" is tracked in localStorage too - otherwise a
    // still-unread notification replays with sound on the next page load.
    persistSeenCrucialIds() {
      try {
        const ids = Array.from(this.seenCrucialIds).slice(-100)
        localStorage.setItem('seenCrucialNotifIds', JSON.stringify(ids))
      } catch (_) {}
    },

    notifTitle(notification) {
      const d = notification.data
      if (d && d.title) return d.title
      const type = notification.type || ''
      return type.split('\\').pop().replace('Notification', '').replace(/([A-Z])/g, ' $1').trim() || 'Notification'
    },

    notifTime(notification) {
      const ts = notification.created_at
      if (!ts) return ''
      if (typeof moment !== 'undefined') return moment(ts).fromNow()
      // Fallback without moment
      const diff = Math.floor((Date.now() - new Date(ts)) / 60000)
      if (diff < 1) return 'just now'
      if (diff < 60) return `${diff}m ago`
      if (diff < 1440) return `${Math.floor(diff / 60)}h ago`
      return `${Math.floor(diff / 1440)}d ago`
    },

    onCrucialKeydown(e) {
      if (e.key === 'Escape' && this.crucialNotification) this.dismissCrucial()
    },

    async dismissCrucial() {
      const notif = this.crucialNotification
      this.crucialNotification = null
      if (notif) {
        try {
          await this.readNotification(notif.id)
        } catch (e) {
          console.error(e)
        }
      }
    },

    playNotificationSound() {
      try {
        const audioContext = new (window.AudioContext || window.webkitAudioContext)()
        const stored = localStorage.getItem('notificationAudio')
        if (stored) {
          const buf = this._base64ToArrayBuffer(stored)
          this._decodeAndPlay(audioContext, buf)
        } else {
          axios.get('/storage/Notifsounds/mixkit-bubble-pop-up-alert-notification-2357.wav', {
            responseType: 'arraybuffer',
          }).then(res => {
            localStorage.setItem('notificationAudio', this._arrayBufferToBase64(res.data))
            this._decodeAndPlay(audioContext, res.data)
          }).catch(() => {})
        }
      } catch (_) {}
    },

    _decodeAndPlay(ctx, buf) {
      ctx.decodeAudioData(buf, decoded => {
        const src = ctx.createBufferSource()
        src.buffer = decoded
        src.connect(ctx.destination)
        src.start(0)
      })
    },

    _base64ToArrayBuffer(b64) {
      const bin = window.atob(b64)
      const bytes = new Uint8Array(bin.length)
      for (let i = 0; i < bin.length; i++) bytes[i] = bin.charCodeAt(i)
      return bytes.buffer
    },

    _arrayBufferToBase64(buf) {
      const bytes = new Uint8Array(buf)
      let bin = ''
      bytes.forEach(b => { bin += String.fromCharCode(b) })
      return window.btoa(bin)
    },

    async readNotification(id) {
      await axios.put('/api/notifications', { id })
      this.getNotifications()
    },

    async readAll() {
      await axios.put('/api/notifications', { all: true })
      this.getNotifications()
    },

    async switchCompanyBranch(companyId) {
      try {
        await branchSwitch.switchTo(this.$store, companyId)
      } catch (e) {
        this.$toasts.push({ type: 'error', message: 'Failed to switch branch.' })
      }
    },

    async addMeToAffiliate() {
      const res = await axios.post('/api/join-affiliates')
      if (res.status === 200) {
        localStorage.removeItem('apc_user_details_v1') // cached user has no affiliate yet
        window.location.href = '/affiliates?new=true'
      }
    },

    // PERF: TTL-cached for the same reason as getUserCompanyDetails above.
    loadDukakitPaymentsStatus() {
      const CACHE_KEY = 'apc_dukakit_payments_v1';
      const CACHE_TTL = 5 * 60 * 1000;
      try {
        const cached = JSON.parse(localStorage.getItem(CACHE_KEY) || 'null');
        if (cached && Date.now() - cached.ts < CACHE_TTL) {
          this.dukakitPaymentsEnabled = !!cached.enabled;
          return;
        }
      } catch (_) {}

      axios.get('/api/dukakit-payments/settings')
        .then(({ data }) => {
          this.dukakitPaymentsEnabled = !!data.enabled;
          try {
            localStorage.setItem(CACHE_KEY, JSON.stringify({ ts: Date.now(), enabled: this.dukakitPaymentsEnabled }));
          } catch (_) {}
        })
        .catch(() => { this.dukakitPaymentsEnabled = false; });
    },

    async loadSetupProgress() {
      const CACHE_KEY = 'apc_milestones_v1';
      const CACHE_TTL = 5 * 60 * 1000;
      try {
        const cached = JSON.parse(localStorage.getItem(CACHE_KEY) || 'null');
        if (cached && Date.now() - cached.ts < CACHE_TTL) {
          this.setupPercentage = cached.data.percentage || 0;
          this.setupCompleted  = cached.data.completed  || 0;
          this.setupTotal      = cached.data.total      || 11;
          this.setupMilestonesLoaded = true;
          return;
        }
      } catch (_) {}
      try {
        const { data } = await axios.get('/api/activation-milestones');
        localStorage.setItem(CACHE_KEY, JSON.stringify({ ts: Date.now(), data }));
        this.setupPercentage = data.percentage || 0;
        this.setupCompleted  = data.completed  || 0;
        this.setupTotal      = data.total      || 11;
        this.setupMilestonesLoaded = true;
      } catch (_) {}
    },

    openSetupCenter() {
      this.isMenuActive = false;
      this.$nextTick(() => this.$root.$emit('open-setup-center'));
    },

    closeShift() {
      this.isMenuActive = false;
      this.$nextTick(() => this.$root.$emit('open-close-shift-modal'));
    },
  },
}
</script>


<style scoped>
    .sidemenu-list li a{
        font-size: 14px;
        font-weight: 500;
        color:#1c252c;
        font-family: "Roboto", sans-serif;
        line-height: 24px;
    }

    .sidemenu-list li a i{
        padding-right: 10px;
    }

    .notification {
        text-decoration: none;
        position: relative;
        margin-top: 30px;
        margin-bottom: 20px;
        margin-right: 15px;
    }

    .notification .badge {
        position: absolute;
        top: -7px;
        right: -9px;
        border-radius: 50%;
        background-color: #fd4719;
        color: white;
    }

    .setup-progress-widget {
        margin-top: 10px;
        background: #f8f9fa;
        border-radius: 8px;
        padding: 10px 12px;
        cursor: pointer;
        transition: background 0.15s ease;
        border: 1.5px solid #e9ecef;
    }
    .setup-progress-widget:hover { background: #e9ecef; }

    .setup-progress-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 6px;
    }

    .setup-progress-label {
        font-size: 0.72rem;
        font-weight: 700;
        text-transform: uppercase;
        letter-spacing: 0.06em;
        color: #495057;
    }

    .setup-progress-pct {
        font-size: 0.72rem;
        font-weight: 700;
        transition: color 0.3s ease;
    }

    .setup-progress-bar-track {
        height: 5px;
        background: #dee2e6;
        border-radius: 99px;
        overflow: hidden;
        margin-bottom: 5px;
    }

    .setup-progress-bar-fill {
        height: 100%;
        border-radius: 99px;
        transition: width 0.5s ease, background 0.3s ease;
    }

    /* ── Notification list items ──────────────────────────────────── */
    .notif-item {
        border-radius: 8px;
        overflow: hidden;
        transition: background .12s;
    }

    .notif-item--unread {
        background: #fff;
        border: 1px solid #e3efff;
    }

    .notif-item--read {
        background: #f8f9fa;
        border: 1px solid #e9ecef;
    }

    .notif-item-header {
        display: flex;
        align-items: center;
        gap: 8px;
        padding: 10px 12px;
        cursor: pointer;
        user-select: none;
    }

    .notif-item-header:hover { background: rgba(0,0,0,.03); }

    .notif-dot {
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background: #0d6efd;
        flex-shrink: 0;
    }

    .notif-dot--read {
        background: #adb5bd;
    }

    .notif-title {
        font-size: .85rem;
        font-weight: 600;
        flex: 1;
        min-width: 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .notif-time {
        font-size: .72rem;
        white-space: nowrap;
        flex-shrink: 0;
    }

    .notif-chevron {
        font-size: .7rem;
        color: #adb5bd;
        flex-shrink: 0;
    }

    .notif-body {
        padding: 10px 12px 12px 28px;
        border-top: 1px solid #f0f0f0;
    }

    /* ── Crucial notification bar ─────────────────────────────────── */
    .crucial-notif-bar {
        position: fixed;
        top: 12px;
        left: 50%;
        transform: translateX(-50%);
        width: calc(100% - 24px);
        max-width: 640px;
        z-index: 2000;
        background: #fff;
        color: #212529;
        border: 1px solid #e9ecef;
        border-left: 4px solid #fd4719;
        border-radius: 8px;
        box-shadow: 0 6px 20px rgba(0,0,0,0.12);
    }

    .crucial-notif-inner {
        display: flex;
        align-items: center;
        gap: 10px;
        padding: 10px 8px 10px 14px;
    }

    .crucial-notif-icon {
        font-size: 1.1rem;
        flex-shrink: 0;
        color: #fd4719;
    }

    .crucial-notif-content {
        flex: 1;
        min-width: 0;
        display: flex;
        flex-direction: column;
    }

    .crucial-notif-content strong {
        font-size: .9rem;
        font-weight: 700;
    }

    .crucial-notif-body {
        font-size: .8rem;
        color: #6c757d;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
    }

    .crucial-notif-actions {
        display: flex;
        align-items: center;
        flex-shrink: 0;
        gap: 4px;
    }

    .crucial-close {
        background: transparent;
        border: none;
        color: #6c757d;
        cursor: pointer;
        font-size: 1rem;
        width: 36px;
        height: 36px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        border-radius: 50%;
        line-height: 1;
        transition: background 0.15s, color 0.15s;
    }

    .crucial-close:hover { background: #f1f3f5; color: #212529; }

    .crucial-slide-enter-active { transition: transform .3s cubic-bezier(0.22,1,0.36,1), opacity .25s ease; }
    .crucial-slide-leave-active { transition: transform .2s ease-in, opacity .18s ease-in; }
    .crucial-slide-enter, .crucial-slide-leave-to { transform: translate(-50%, -120%); opacity: 0; }

    .setup-progress-sub {
        font-size: 0.68rem;
        color: #6c757d;
        margin: 0;
        line-height: 1.3;
    }

</style>
